/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ISurveyUnitsOfMeasure } from 'app/shared/model/survey-units-of-measure.model';
import { ISurveyQuestionOption } from 'app/shared/model/survey-question-option.model';

export interface ISurveyAnswer {
  id?: string;
  answerNumeric?: number | null;
  answerText?: string | null;
  answer?: boolean | null;
  comment?: string | null;
  active?: boolean | null;
  cursor?: number;
  lastupdated?: number | null;
  microSec?: number | null;
  timestampentry?: number | null;
  unitOfMeasure?: ISurveyUnitsOfMeasure | null;
  questionOption?: ISurveyQuestionOption;
}

export const defaultValue: Readonly<ISurveyAnswer> = {
  answer: false,
  active: false,
};
